import {
  TreePillsInput,
  TreePillsInputProps,
} from "@/-components/tree/tree-pills-input"
import { useTranslation } from "react-i18next"
import { Empty, useGetActivityTypeTreeSuspense } from "@/orval/gen"

interface ActivityTypeTreeSelectProps extends Omit<
  TreePillsInputProps<Empty>,
  "tree" | "initialCheckedState" | "onCheckedStateChange" | "onChange"
> {
  value?: string[] | null | undefined
  onChange?: (value: string[]) => void
}

export function ActivityTypeTreeSelect({
  value,
  onChange,
  ...props
}: ActivityTypeTreeSelectProps) {
  const { t, i18n } = useTranslation("app_server")
  const { data: activityTypeTree } = useGetActivityTypeTreeSuspense({
    language: i18n.language,
  })

  return (
    <TreePillsInput
      label={t("ActivityTypes")}
      placeholder={t("ActivityTypes")}
      tree={activityTypeTree.tree}
      initialCheckedState={value ?? []}
      onCheckedStateChange={onChange}
      {...props}
    />
  )
}
